module.exports = __webpack_public_path__ + "img/hazardEquip70.62654b5f.jpg";